import { render, staticRenderFns } from "./EwalletList.vue?vue&type=template&id=7ad24c62&"
import script from "./EwalletList.vue?vue&type=script&lang=js&"
export * from "./EwalletList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports